import { createContext } from 'react';

interface ConfirmOptions {
  [key: string]: unknown;
  modalTargetId?: string;
  onConfirmAction?: () => Promise<void>;
  open?: boolean;
}

type ConfirmFunction = (options?: ConfirmOptions) => Promise<boolean>;

interface ConfirmationDialogContextValue {
  confirm: ConfirmFunction;
}

export const ConfirmationDialogContext = createContext<ConfirmationDialogContextValue | null>(null);
